import styled from 'styled-components';

import paths from '../../AppRouter/paths';
import colors from '../../assets/theme/colors';

interface StylesImageProps {
  marginRightVariant?: string;
}

export const Wrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  background: '#000000',
  justifyContent: 'space-between',
  padding: '25px',
  color: colors.white,
  flexShrink: 0,
  '@media screen and (min-width: 1100px)': {
    paddingTop: '81px',
    paddingBottom: window.location.pathname === paths.wins ? '196px' : '83px',
    borderTop: '3px solid white',
  },
});

export const LogoContainer = styled('div')({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  '@media screen and (min-width: 1100px)': {
    paddingBottom: '30px',
    width: '100%',
    columnGap: '46px',
  },
});

export const StylesImage = styled('img')<StylesImageProps>((props) => ({
  marginRight: props.marginRightVariant || '0px',
  '@media screen and (min-width: 1100px)': {
    width: '560px',
  },
}));

export const Description = styled('span')({
  fontWeight: '500',
  fontFamily: 'Helvet,sans-serif',
  fontSize: '9px',
  lineHeight: '11px',
  '@media screen and (min-width: 1100px)': {
    fontFamily: 'Helvet,sans-serif',
    margin: 'auto',
    fontSize: '16px',
    lineHeight: '100%',
  },
});

export const DescriptionAbr = styled('span')({
  fontWeight: '700',
  fontSize: '9px',
  lineHeight: '12px',
  paddingBottom: '10px',
  textAlign: 'start',
});
export const LogoutButton = styled('button')({
  padding: '18px 38px',
  border: '1px solid white',
  borderRadius: '8px',
  fontSize: '18px',
  lineHeight: '100%',
  fontWeight: '700',
  background: 'transparent',
  color: '#fff',
  cursor: 'pointer',
});
